<template>
  <div>
    <Upload
      action="https://v0.api.upyun.com/static-store"
      :accept="accept"
      :data="extra"
      :headers="{ 'X-Requested-With': null }"
      :show-upload-list="false"
      :max-size="maxSize && (1024 * maxSize)"
      :disabled="disabled"
      :before-upload="handleBeforeUpload"
      :on-progress="handleProgress"
      :on-error="handleError"
      :on-success="handleSuccess"
      :on-exceeded-size="handleOverSize">
      <Button icon="ios-cloud-upload-outline">{{ placeholder }}{{ progressTip }}</Button>
      <span slot="tip" v-if="this.maxSize" class="margin-left-base">{{ tip }}</span>
    </Upload>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Uploader',
  props: {
    saveKey: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: '开始上传'
    },
    maxSize: {
      type: Number,
      default: void 0
    },
    accept: {
      type: String,
      default: 'image/jpg,image/jpeg'
    }
  },
  data () {
    return {
      disabled: false,
      extra: {},
      progress: 0
    }
  },
  computed: {
    tip () {
      if (this.maxSize) return `请勿超过${this.maxSize}Mb`
      return ''
    },
    progressTip () {
      if (this.progress) {
        return ` - ${parseInt(this.progress * 100)}%`
      } else {
        return ''
      }
    }
  },
  created () {
    this.getExtraData()
  },
  handlers: {
    handleBeforeUpload () {
      this.progress = 0
      this.disabled = true
      this.$emit('before-upload')
    },
    handleProgress ({ loaded, total }) {
      this.progress = loaded / total
    },
    handleError (error) {
      this.progress = 0
      this.disabled = false
      // eslint-disable-next-line no-console
      console.log(error)
      window.toast.error('上传失败')
    },
    handleSuccess ({ url }) {
      this.progress = 1
      this.disabled = false
      this.$emit('on-uploaded', url)
      window.toast.success('上传成功')
    },
    handleOverSize () {
      this.progress = 0
      this.disabled = false
      window.toast.error(`图片不能超过${this.maxSize}Mb`)
    }
  },
  methods: {
    ...mapActions([ 'getUploadSignature' ]),

    async getExtraData () {
      const { signature, policy } = await this.getUploadSignature(this.saveKey)
      this.extra = {
        authorization: `UPYUN admin:${signature}`,
        policy
      }
    }
  }
}
</script>
